import { isEqual } from 'lodash';
import React from 'react';
import { PiTrashDuotone } from 'react-icons/pi';
import { Button } from 'rizzui';
import CustomSearchInput from '../../../components/forms/CustomSearchInput';
import CustomSelect from '../../../components/forms/CustomSelect';
import DateField from '../../../components/forms/DateField';
import FormLabel from '../../../components/forms/FormLabel';
import { FilterOptions } from '../../../hooks/useFilters';

interface OrganisationsFiltersProps {
    updateFilters: (filters: any) => void
    resetFilters: (limit: any) => void
    filters: FilterOptions
}

const OrganisationsFilters: React.FC<OrganisationsFiltersProps> = ({ filters, updateFilters, resetFilters }) => {

    return (
        <>
            <CustomSelect
                isSearchable
                id={'active'}
                label="Estado"
                options={[
                    { label: 'Todos', value: null },
                    { label: 'Activos', value: true },
                    { label: 'Desactivados', value: false }
                ]}
                onChange={(e: any) => {
                    if (e.value === null) {
                        updateFilters({ active: null });
                        return;
                    }
                    updateFilters({ active: e.value });
                }}
                value={filters.filter_filters?.active !== null && filters.filter_filters?.active !== undefined
                    ? { label: filters.filter_filters?.active ? 'Activo' : 'Desactivado', value: filters.filter_filters?.active }
                    : { label: 'Todos', value: null }}
            />

            <FormLabel label='Buscar (nombre, CIF, dirección)'>
                <CustomSearchInput
                    onSearch={(e) => updateFilters({ search_text: e || null })}
                    defaultValue={filters.filter_filters?.search_text || ''}
                    placeholder="Buscar..."
                />
            </FormLabel>

            <FormLabel label='Nombre'>
                <CustomSearchInput
                    onSearch={(e) => updateFilters({ name: e || null })}
                    defaultValue={filters.filter_filters?.name || ''}
                    placeholder="Filtrar por nombre"
                />
            </FormLabel>

            <FormLabel label='CIF'>
                <CustomSearchInput
                    onSearch={(e) => updateFilters({ cif: e || null })}
                    defaultValue={filters.filter_filters?.cif || ''}
                    placeholder="Filtrar por CIF"
                />
            </FormLabel>

            <FormLabel label='Dirección'>
                <CustomSearchInput
                    onSearch={(e) => updateFilters({ address: e || null })}
                    defaultValue={filters.filter_filters?.address || ''}
                    placeholder="Filtrar por dirección"
                />
            </FormLabel>

            <DateField
                isClearable
                className="w-full"
                label="Fecha de Creación"
                placeholderText="Selecciona las fechas"
                selectedDateField={filters.filter_filters?.between_dates?.type || "createdAt"}
                dateTypesOptions={[
                    { label: "Fecha de creación", value: "createdAt" },
                    { label: "Fecha de modificación", value: "updatedAt" }
                ]}
                startDate={filters.filter_filters?.between_dates?.startDate ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.endDate ? new Date(filters.filter_filters.between_dates.endDate) : null}
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1], type: date[2] } : null;

                    if (between_dates && !isEqual(filters_between_dates, between_dates)) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1], type: date[2] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />

            <Button
                size="sm"
                onClick={() => {
                    resetFilters(50);
                }}
                variant="flat"
                className="h-9 bg-gray-200/70"
            >
                <PiTrashDuotone className="me-1.5 h-[17px] w-[17px]" /> Limpiar
            </Button>
        </>
    );
};

export default OrganisationsFilters;
